var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.605,
    height: 31.367,
    viewBox: "0 0 38.605 31.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M38.605,51.713a16.5,16.5,0,0,1-4.56,1.25,7.87,7.87,0,0,0,3.482-4.374A15.817,15.817,0,0,1,32.508,50.5a7.914,7.914,0,0,0-13.69,5.412,8.149,8.149,0,0,0,.183,1.8A22.4,22.4,0,0,1,2.688,49.443,7.917,7.917,0,0,0,5.12,60.021a7.816,7.816,0,0,1-3.576-.975v.087a7.951,7.951,0,0,0,6.341,7.777,7.9,7.9,0,0,1-2.075.261,7,7,0,0,1-1.5-.135,7.99,7.99,0,0,0,7.4,5.513,15.9,15.9,0,0,1-9.813,3.376A14.824,14.824,0,0,1,0,75.815a22.281,22.281,0,0,0,12.141,3.552c14.564,0,22.526-12.064,22.526-22.521,0-.35-.012-.688-.029-1.023A15.789,15.789,0,0,0,38.605,51.713Z",
    transform: "translate(0 -48)",
    fill: "#74767d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.135ea8034ca3fb8b4a436ae3c8b1547e.svg";
export { ForwardRef as ReactComponent };